// INFO: use global state for handle map-settings to prevent duplicate and make independent from other packages

import { Map, MapProperty } from 'user-auth/types/__generated/gql/graphql'
import { create } from 'zustand'

type State = {
  mapName: string
  properties: MapProperty[]
  currentProperty: MapProperty | undefined
  initMapData: (map: Map) => void
  setCurrentProperty: (property: MapProperty) => void
  setProperties: (properties: MapProperty[]) => void
}

const useMapSettingsStore = create<State>((set) => ({
  mapName: '',
  properties: [],
  currentProperty: undefined,
  initMapData: (map: Map) =>
    set({
      mapName: map.name,
      properties: map.properties
    }),
  setProperties: (properties: MapProperty[]) =>
    set({
      properties: properties.map((property, key) => ({
        ...property,
        id: key
      }))
    }),
  setCurrentProperty: (property: MapProperty) =>
    set({ currentProperty: property })
}))

export const useProperties = () =>
  useMapSettingsStore((state) => state.properties)

export const useCurrentProperty = () =>
  useMapSettingsStore((state) => state.currentProperty)

export const useSetCurrentProperty = () =>
  useMapSettingsStore((state) => state.setCurrentProperty)

export const useSetProperties = () =>
  useMapSettingsStore((state) => state.setProperties)

export const useInitMap = () =>
  useMapSettingsStore((state) => state.initMapData)
